
export default {
  i18nComponentKey: 'ReviewsNew.components.MediaPreviewItem',
  props: {
    item: { type: Object, required: true }
  }
};
